
import Vue, { PropType } from 'vue'
import { PublicPlace } from '@/models'

import WebsitePublicPlaceEditListHeader from './WebsitePublicPlaceEditListHeader.vue'
import WebsitePublicPlaceEditListItem from './WebsitePublicPlaceEditListItem.vue'

export type EditOption = {
  toiletId: string;
  checked: boolean;
}

export default Vue.extend({
  name: 'WebsitePublicPlaceEditList',

  props: {
    toilets: Array as PropType<Array<PublicPlace>>,
    value: Array as PropType<Array<EditOption>>,
    currentPage: Number
  },

  components: {
    WebsitePublicPlaceEditListHeader,
    WebsitePublicPlaceEditListItem
  },
  computed: {
    currentToilets() {
      return this.toilets.slice(this.currentPage === 1 ? 0 : (this.currentPage - 1) * 50, (this.currentPage - 1)* 50 + 50)
    }
  }
})
